import React, { useState } from 'react';
import { User, Mail, Phone, MapPin, Building, Calendar, X } from 'lucide-react';

interface ProfileProps {
  onClose: () => void;
}

export default function Profile({ onClose }: ProfileProps) {
  const [profile] = useState({
    name: 'Admin User',
    email: 'admin@company.com',
    phone: '+1 (555) 123-4567',
    location: 'New York, NY',
    department: 'M&A Team',
    joinDate: '2023-01-01',
    role: 'Administrator',
    bio: 'Senior M&A professional with 10+ years of experience in deal execution and integration.'
  });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
          <h3 className="text-lg font-medium text-gray-900">Profile</h3>
          <button onClick={onClose}>
            <X className="w-5 h-5 text-gray-400 hover:text-gray-600" />
          </button>
        </div>

        <div className="p-6">
          <div className="flex items-center space-x-6 mb-8">
            <div className="w-24 h-24 rounded-full bg-blue-100 flex items-center justify-center">
              <span className="text-3xl font-medium text-blue-800">
                {profile.name[0]}
              </span>
            </div>
            <div>
              <h4 className="text-xl font-medium text-gray-900">{profile.name}</h4>
              <p className="text-sm text-gray-500">{profile.role}</p>
              <p className="text-sm text-gray-500">{profile.department}</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Email</label>
                <div className="mt-1 flex items-center">
                  <Mail className="w-5 h-5 text-gray-400 mr-2" />
                  <span className="text-sm text-gray-900">{profile.email}</span>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Phone</label>
                <div className="mt-1 flex items-center">
                  <Phone className="w-5 h-5 text-gray-400 mr-2" />
                  <span className="text-sm text-gray-900">{profile.phone}</span>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Location</label>
                <div className="mt-1 flex items-center">
                  <MapPin className="w-5 h-5 text-gray-400 mr-2" />
                  <span className="text-sm text-gray-900">{profile.location}</span>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Department</label>
                <div className="mt-1 flex items-center">
                  <Building className="w-5 h-5 text-gray-400 mr-2" />
                  <span className="text-sm text-gray-900">{profile.department}</span>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Join Date</label>
                <div className="mt-1 flex items-center">
                  <Calendar className="w-5 h-5 text-gray-400 mr-2" />
                  <span className="text-sm text-gray-900">
                    {new Date(profile.joinDate).toLocaleDateString()}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6">
            <label className="block text-sm font-medium text-gray-700">Bio</label>
            <p className="mt-1 text-sm text-gray-600">{profile.bio}</p>
          </div>
        </div>
      </div>
    </div>
  );
}